export default __webpack_public_path__ + "static/media/Uae_assessment_completed.796dc0eb.svg";